/***
 * 创建人：李珊
 * 时间：2020-12-31
 * 描述：知识库管理：查看详情操作
 * 更新说明:
 */
import { Component, OnInit, Output, EventEmitter, ViewChild, Input } from '@angular/core';
import { SwMassageBoxService } from 'src/app/librarys/serves/sw-massage-box.service';
import { KmsService } from 'src/app/areas/kms/kms.service';
import { SwModalframeComponent } from 'src/app/librarys/components/basic-components/sw-modal-frame/sw-modal-frame.component';
declare var $: any;
@Component({
  selector: 'app-knowledge-base-view',
  templateUrl: './knowledge-base-view.component.html',
  styleUrls: ['./knowledge-base-view.component.css']
})
export class KnowledgeBaseViewComponent implements OnInit {
  
  @ViewChild('modal') modal: SwModalframeComponent;    //弹出层组件
  @Input() param:any;
  @Output() callback = new EventEmitter(); //抛出事件
  //数据绑定对象
  model: any = { }; 
  constructor(
    private box: SwMassageBoxService,  //消息提示框
    private service: KmsService,   //请求服务
  ) { 

  }

  ngOnInit() {
    this.clickLoca(this.param["selectedData"]);
  }
  //知识库点击新增 或者 修改
  clickLoca(selectedData: any) {
    // 查询知识库信息
    this.service.getknowledgebaseById(selectedData.kgDbId).subscribe(
      data => {
        if (data["code"] == '200') {
          this.model = data["data"];
        }
      }
    )
  }
}


